import * as Blockly from 'blockly';
export function addNewBlock(type, block) {
    // FIXME: can't update to blockly > 8.x.x, need new generator!
    // @ts-ignore
    Blockly.JavaScript[type] = function (block) {
        return `${block.type}`;
    };
    // console.log('Blockly Blocks', Blockly.Blocks);
    Blockly.Blocks[type] = {
        init: function () {
            // @ts-ignore
            this.jsonInit(block);
        },
    };
}
